// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--1c9am","joe":"Footer-module--joe--3lHfF"};